var $ = jQuery.noConflict();


$(function(){


function sgCollectionDescription() {
    if ($('body').hasClass('template-collection') || $('body').hasClass('template-search')) {
        // Remove existing "Read More" button if it exists (for resize scenarios)
        $('.collection-info-item .collection-description + button.button').remove();
        
        // Remove the remove-overflow class FIRST to get accurate content height
        $('.collection-info-item .collection-description').removeClass('remove-overflow');
        
        // Also temporarily remove max-height to measure true content height
        $('.collection-info-item .collection-description').css('max-height', 'none');

        // NOW measure the content height after removing constraints
        var $contentHeight = $('.collection-description').outerHeight(true);

        //console.log("$contentHeight" + $contentHeight);

        if ($contentHeight > 319) {
            // Reset max-height to apply the overflow constraint
            $('.collection-info-item .collection-description').css('max-height', '');
            
            $('.collection-info-item .collection-description').after('<button class="button button--secondary"><span>Read More</span></button>');

            $('.collection-info-item .collection-description + button.button').off('click').on('click', function() {
                $('.collection-info-item .collection-description').css('max-height', '9999px');
                $('.collection-info-item .collection-description + button.button').remove();
            
                setTimeout(() => {
                    $('.collection-description').addClass('remove-overflow');
                    $('.collection-description').css('max-height', 'unset');
                }, 500);
            });
        } else {
            $('.collection-info-item .collection-description').addClass('remove-overflow');
        }
    }
}

// Initialize collection description on page load
sgCollectionDescription();

// Add custom arrow to subcat-grid-link__title when inside categories_uncomplicated_category_icons div
if ($('div[id*="categories_uncomplicated_category_icons"]').length > 0) {
    if ( !$('body').hasClass('custom-fdp-theme') ) {
        $('div[id*="categories_uncomplicated_category_icons"] .subcat-grid-link__title').append('<span class="custom-arrow"></span>');
    }
}

var fdpShowShop = true; 
// Format product count text, optionally including the "Shop" prefix.
function sgProductCountText(count) {
    if (count == 0) {
        return fdpShowShop ? 'Shop all products' : 'View all products';
    }

    return fdpShowShop && !$('body').hasClass('custom-fdp-theme') ? 'Shop ' + count + ' products' : count + ' products';
}

// Replace parentheses format with product count text in product count spans.
function sgUpdateProductCountFormat() {
    if ($('body').hasClass('template-collection')) {
        // Check if #uncomplicated-icons exists
        if ($('#uncomplicated-icons').length > 0) {
            // For each .subcat-grid-link check if it has span.pc[data-count]
            $('.subcat-grid-link').each(function() {
                var $link = $(this);
                var $title = $link.find('.subcat-grid-link__title');
                var $span = $link.find('span.pc[data-count]');
                
                // If span exists, update text and keep it inside title
                if ($span.length > 0) {
                    var count = $span.attr('data-count');
                    var text = sgProductCountText(count);
                    $span.text(text);
                    // Keep span inside the title - move it inside if needed
                    if (!$span.parent().is($title)) {
                        // Move span inside the title
                        $title.append($span.detach());
                    }
                } else {
                    // If span doesn't exist, create it inside the title
                    var $parent = $link.closest('[data-products-count]');
                    if ($parent.length > 0) {
                        var count = $parent.attr('data-products-count');
                        var text = sgProductCountText(count);
                        var $newSpan = $('<span class="pc" data-count="' + count + '">' + text + '</span>');
                        $title.append($newSpan);
                    }
                }
            });
        }
    }
}

// Initialize product count format on page load
sgUpdateProductCountFormat();



    // Run Scripts after Window Resize
	/*! run scirpt after resize by Dolan Antenucci https://stackoverflow.com/users/318870/dolan-antenucci-   - https://stackoverflow.com/posts/5926068/revisions https://stackoverflow.com/questions/5489946/jquery-how-to-wait-for-the-end-of-resize-event-and-only-then-perform-an-ac/5926068#5926068 */
	var rtime;
	var timeout = false;
	var delta = 100;
	$(window).resize(function() {
		rtime = new Date();
		if (timeout === false) {
			timeout = true;
			setTimeout(resizeend, delta);
		}
	});

	function resizeend() {

	   if (new Date() - rtime < delta) {
			setTimeout(resizeend, delta);
		} else {
			timeout = false;

sgCollectionDescription();
//sgUpdateProductCountFormat();

		}

	} // resizeend()


});
